import styled from '@emotion/styled';

export const Skeleton = styled.div`
	width: ${(props) => props.size ?? props.width ?? '100%'};
	height: ${(props) => props.size ?? props.height ?? 'var(--paragraph3-font-size)'};
	background-color: ${(props) => props.color ?? 'var(--skeletonBackground)'};
	border-radius: ${(props) => props.borderRadius ?? '4px'};
	position: relative;
	overflow: hidden;

	&.circle {
		border-radius: 50%;
	}

	:after {
		content: '';
		height: 100%;
		left: 0;
		position: absolute;
		right: 0;
		top: 0;
		transform: translateX(-100%);
		z-index: 1;
		background: linear-gradient(90deg, rgba(255, 255, 255, 0), var(--skeletonAnimation), rgba(255, 255, 255, 0));
		animation: animation 1.2s infinite;
	}

	@keyframes animation {
		from {
			transform: translateX(-100%);
		}
		to {
			transform: translateX(100%);
		}
	}
`;
